/*global google*/
/*global data*/
/*eslint no-console: 0 */
/*eslint no-unused-vars: 0*/
(function($) {
    var map = '';
    var markers = {};
    var markerStrokeColor = '#333';
    var pinColors = {
        taberna: '#c685ab',
        jatetxea: '#a0c029',
        ostatua: '#4c648b',
        zer_ikusi: '#e87d77',
        done_jakue: '#fbd260',
        orokorra: '#f0a477',
        bertokoa: '#737375',
        souvenir: '#89a1ab',
        ikusi_beharrekoak: '#89546d',
    };
    var markerPath = "m 9.2962177,0.28037908 c 2.6094053,-0.55254002 5.4214673," +
        "-0.28489001 7.8403753,0.77171002 2.226123,0.9576401 4.109173," +
        "2.5633001 5.319008,4.5233402 1.203002,1.94961 1.757826,4.2510601" +
        " 1.469405,6.4799397 -0.284629,1.926061 -1.24627,3.704801 -2.395378," +
        "5.315791 -1.02313,1.42065 -2.237502,2.71209 -3.41545," +
        "4.02441 C 16.103606,23.61697 14.054327,25.80914 " +
        "12.004299,28 9.6438347,25.68756 7.3076589,23.35278 5.0420717" +
        ",20.96179 3.5256082,19.36055 2.0516473,17.68061 " +
        "1.1097402,15.72752 0.13367796,13.7688 -0.20483182," +
        "11.554219 0.11925732,9.4240494 0.45852619,7.1726393" +
        " 1.6023247,5.0361493 3.3168853,3.3950192 4.9236696," +
        "1.8561792 7.0275921,0.7524391 9.2962177,0.28037908 " +
        "M 11.426703,5.8283193 c -1.7669324,0.14314 -3.4200132," +
        "1.08032 -4.3740654,2.4446101 -0.7794833,1.08499 -1.0899113" +
        ",2.4374496 -0.8789107,3.7200596 0.2079638,1.343351 " +
        "1.0064219,2.598651 2.170724,3.435421 0.9350702,0.68483" +
        " 2.1054311,1.0949 3.3000751,1.15676 1.187825,0.069 " +
        "2.397656,-0.20229 3.413196,-0.7701 0.929759,-0.51589" +
        " 1.697854,-1.27138 2.192729,-2.15767 0.6732,-1.198771" +
        " 0.829568,-2.633441 0.421991,-3.9297506 -0.404553," +
        "-1.33504 -1.403369,-2.5064201 -2.713391,-3.1970901" +
        " -1.056523,-0.56943 -2.3134,-0.81265 -3.532348,-0.70224 z";
    var waypts = [];

    function addWayPoints(point) {
        waypts.push({
            location: point,
            stopover: true,
        });
    }

    function calculateAndDisplayRoute(src, end, directionsService, directionsDisplay) {
        var polylineProps = {
            strokeColor: pinColors['done_jakue'],
            strokeOpacity: 0.8,
            strokeWeight: 4,
        };
        directionsDisplay.setOptions({
            suppressMarkers: true,
            preserveViewport: true,
            polylineOptions: polylineProps,
        });
        directionsService.route({
            origin: src,
            destination: end,
            waypoints: waypts,
            optimizeWaypoints: true,
            travelMode: 'WALKING',
        }, function(response, status) {
            if (status === 'OK') {
                directionsDisplay.setDirections(response);
            } else {
                window.alert('Directions request failed due to ' + status);
            }
        });
    }

    function loadMap(mapObject) {
        var latlng = new google.maps.LatLng(43.267298, -2.49628);
        var myOptions = {
            zoom: 14,
            center: latlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        };
        map = new google.maps.Map(mapObject, myOptions);

        var mapType = $(mapObject).data('mapType');
        if (mapType && mapType === 'doneJakue') {
            var directionsService = new google.maps.DirectionsService;
            var directionsDisplay = new google.maps.DirectionsRenderer;
            var src = new google.maps.LatLng(43.271928, -2.495234);
            var end = new google.maps.LatLng(43.265616, -2.504680);
            addWayPoints(new google.maps.LatLng(43.267124,-2.493687));
            addWayPoints(new google.maps.LatLng(43.266935,-2.497826));
            addWayPoints(new google.maps.LatLng(43.267465,-2.498723));
            directionsDisplay.setMap(map);
            calculateAndDisplayRoute(src, end, directionsService, directionsDisplay);
        }

        if (mapType !== 'generalMap') {
            var type = $('.map-canvas').data('type');
            var subType = $('.map-canvas').data('subtype');
            var subTypeField = $('.map-canvas').data('subtypeField');
            loadMarkers(type, subType, subTypeField);
        }
    }

    function loadMarkers(type, subType, subTypeField) {
        $.ajax({
            url: data.ajax_url,
            type: 'post',
            data: {
                action: 'load_items',
                type: type,
                subtype: subType,
                subtypeField: subTypeField,
            },
            success: function( response ) {
                addMarkers(map, response);
            },
        });
    }

    function addMarkers(map, data) {
        var infowindow = new google.maps.InfoWindow();
        var bounds = new google.maps.LatLngBounds();
        var mapType = $('.map-canvas').data('mapType');
        var markerIcon = {
          url: 'http://image.flaticon.com/icons/svg/252/252025.svg',
          scaledSize: new google.maps.Size(20, 20),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(32,65),
        };

        $.each(data, function(index, point) {
            var fillcolor = pinColors[point.type];
            if (point.subtype && point.subtype === 'ikusi_beharrekoak') {
                fillcolor = pinColors[point.subtype];
            }
            var latlng = new google.maps.LatLng(point.point.lat, point.point.lng);
            var marker = new google.maps.Marker({
                animation: google.maps.Animation.DROP,
                id: point.id,
                    icon: {
                        path: markerPath,
                        strokeColor: markerStrokeColor,
                        fillColor: fillcolor,
                        fillOpacity: 1.0,
                        anchor: new google.maps.Point(18, 35),
                        scaledSize: new google.maps.Size(25, 35),
                    },
                position: latlng,
                map: map,
                clickable: true,
            });
            markers[point.id] = marker;
            google.maps.event.addListener(marker, 'click', function() {
                var content = "<p class='map-content'><span class='map-title'>" +
                    point.title + "</span><br />" +
                    point.address + "<br />" +
                    point.telephone + "</p>";
                infowindow.setContent(content);
                infowindow.open(map, this);
                if (mapType === 'loadWithList') {
                    loadRelatedPoint($('a[data-id="' + point.id + '"]'), false);
                }
                if (mapType === 'loadFeatured') {
                    loadFeaturedPoint($('[data-id="' + point.id + '"]'), false);
                }
            });
            bounds.extend(latlng);
        });
        google.maps.event.addListener(infowindow, 'closeclick',function(){
            map.fitBounds(bounds);
        });
        map.fitBounds(bounds);
    }

    function loadRelatedPoint(object, trigger) {
        var id = parseInt(object.data('id'));
        if (trigger){
            google.maps.event.trigger(markers[id], 'click');
        }
        $.ajax({
            type : "POST",
            url : data.ajax_url,
            data : {
                action : "get_featured_point",
                id: object.data('id'),
                template: 'ikusi-normal',
            },
            success: function (result) {
                $('#ikusiWrapper').empty().html(result);
                $('.carousel').carousel({
                    pause: false,
                });
                $('.scrollTop').on('click', function() {
                    $('html,body').animate({scrollTop:0},500);
                });
            },
        });

        $('a[data-point-loader="true"].active').removeClass('active');
        object.addClass('active');
    }

    function loadFeaturedPoint(object, trigger) {
        var id = parseInt(object.data('id'));
        if (trigger){
            google.maps.event.trigger(markers[id], 'click');
        }
        $.ajax({
            type : "POST",
            url : data.ajax_url,
            data : {
                action : "get_featured_point",
                id: object.data('id'),
                template: 'ikusi-featured',
            },
            success: function ( result ) {
                $('.ikusi-featured').empty().html(result);
                $('.carousel').carousel({
                    pause: false,
                });
                $('html,body').animate({scrollTop:0},500);
            },
        });
    }

    function loadGeneralSection(object, clear) {
        $.ajax({
            type : "POST",
            url : data.ajax_url,
            data : {
                action : "get_section_list",
                type: object.data('postType'),
                subType: object.data('subType'),
                subTypeField: object.data('subTypeField'),
            },
            success: function ( result ) {
                $('#content-wrapper').html(result);
                $('.map-trigger').each(function(){
                    $(this).on('click', function(){
                        var id = parseInt($(this).data('id'));
                        google.maps.event.trigger(markers[id], 'click');
                        $('html,body').animate({scrollTop:0},1500);
                    });
                });
            },
        });

        if (clear) {
            clearMarkers();
        }

        var type = $(object).data('postType');
        var subType = $(object).data('subType');
        var subTypeField = $(object).data('subTypeField');
        loadMarkers(type, subType, subTypeField);

        $('[data-map-loader="true"]').removeClass('active');
        object.addClass('active');
    }

    function clearMarkers() {
        $.each(markers, function(index, marker) {
            markers[index].setMap(null);
            delete markers[index];
        });
    }

    function loadMonth(object) {
        $.ajax({
            type : "POST",
            url : data.ajax_url,
            data : {
                action : "get_month_agenda",
                year: object.data('year'),
                month: object.data('month'),
            },
            success: function ( result ) {
                $('#agenda-wrap').html(result);
                bindAgenda();
            },
        });
    }

    function bindAgenda() {
        $('[data-type="month-selector"]').on('click', function(event) {
            event.preventDefault();
            loadMonth($(this), true);
        });
    }

    $(document).ready(function() {
        if ($('.map-canvas').length > 0) {
            loadMap($('.map-canvas')[0]);
            $('.map-trigger').each(function(){
                $(this).on('click', function(){
                    var id = parseInt($(this).data('id'));
                    google.maps.event.trigger(markers[id], 'click');
                    $('html,body').animate({scrollTop:0},1500);
                });
            });
        }

        if ($('[data-ikusi-loader="true"]').length > 0) {
            $('[data-ikusi-loader="true"]').on('click', function(event) {
                event.preventDefault();
                loadFeaturedPoint($(this), true);
            });
            var url_string = window.location.href;
            var url = new URL(url_string);
            var active = url.searchParams.get("active");
            if (active) {
                setTimeout(function() {
                    $('div[data-id="'+ active +'"]').trigger('click');
                }, 200);
            }
        }

        if ($('a[data-point-loader="true"]').length > 0) {
            $('a[data-point-loader="true"]').on('click', function(event) {
                event.preventDefault();
                loadRelatedPoint($(this), true);
            });
            setTimeout(function() {
                $('a[data-point-loader="true"]:first-child').trigger('click');
            }, 500);
        }

        if ($('[data-map-loader="true"]').length > 0) {
            $('[data-map-loader="true"]').on('click', function(event) {
                event.preventDefault();
                loadGeneralSection($(this), true);
            });
            setTimeout(function() {
                $('[data-map-loader="true"]:first-child').trigger('click');
            }, 500);
        }

        $('.scrollTop').on('click', function() {
            $('html,body').animate({scrollTop:0},500);
        });

        if ($('.panel-collapse').length > 0) {
            $('.panel-collapse').on('shown.bs.collapse', function(e) {
                var $panel = $(this).closest('.panel');
                $('html,body').animate({
                    scrollTop: $panel.offset().top,
                }, 500);
            });
        }

        if ($('.imagemap').length > 0) {
            $('.imagemap').imageMapResize();
        }

        if ($('[data-type="month-selector"]').length > 0) {
            bindAgenda();
        }
    });
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/theme.js